const features = [
  {
    id: 1,
    icon: 'ri-money-dollar-circle-line',
    title: '完全免费',
    desc: '所有影视资源免费在线观看，无隐藏收费，无会员门槛，真正做到零成本享受高品质影视内容。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全线支持 720P 至 1080P 高清播放，画面清晰细腻，色彩还原准确，给您影院级的观影享受。',
  },
  {
    id: 3,
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '全球 CDN 加速节点覆盖，视频秒开不等待。智能码率自适应，网络不佳时也能流畅播放不卡顿。',
  },
  {
    id: 4,
    icon: 'ri-calendar-check-line',
    title: '每日更新',
    desc: '热门影视剧集每日同步更新，院线电影第一时间上线。资源库持续扩充，精彩从不断档。',
  },
];

const contactInfo = {
  email: 'contact@wowocinema.com',
  wechat: 'wowocinema',
  tips: '如有版权争议、内容建议或商务合作，欢迎通过邮件或微信与我们联系。我们珍视每一位用户的反馈，并将尽快回复您的消息。',
};

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium tracking-wide mb-3">
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            平台优势
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-lg mx-auto">
            四大核心优势，为您打造极致免费观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mb-16">
          {features.map((feat) => (
            <div
              key={feat.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-6 text-center transition-all hover:border-primary-200 cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 rounded-2xl bg-primary-50 text-primary-500 group-hover:bg-primary-100 transition-colors">
                <i className={`${feat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-100/70">
      <div className="max-w-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium tracking-wide mb-3">
            联系
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-lg mx-auto">
            版权合作、内容投稿、广告咨询，欢迎随时联系
          </p>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-8 md:gap-12 mb-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-400 mb-0.5">电子邮箱</div>
                <div className="text-sm font-medium text-foreground-800">{contactInfo.email}</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-400 mb-0.5">微信</div>
                <div className="text-sm font-medium text-foreground-800">{contactInfo.wechat}</div>
              </div>
            </div>
          </div>
          <p className="text-center text-foreground-500 text-sm leading-relaxed">
            {contactInfo.tips}
          </p>
        </div>
      </div>
    </section>
  );
}